module.exports = __webpack_public_path__ + "slide1-welcomeoctopus-ie11.8e959000e1eb8dd66b6822ca04b075b3.hashedasset.svg";